import React from 'react';
import { SvgIcon, Typography } from '@mui/material';

import { StyledLabelTag } from './DS_LabelTagStyles';

/**
 * Render LabelTag tag
 *
 * @returns {React.ReactElement}
 */
const LabelTag = ({ icon, text, children, isLabel = true }) => {
  return (
    <StyledLabelTag isLabel={isLabel} icon={icon}>
      {icon ? <SvgIcon component={icon} inheritViewBox={true}></SvgIcon> : null}
      <Typography variant="DS_labelSmallBold" component="p">
        {children || text}
      </Typography>
    </StyledLabelTag>
  );
};

export default LabelTag;
